import { Footer } from "../First";
export function Contact(){

    return(

        <>
        
        <h1> Contact Page Bro </h1>

        <Footer />
        </>
    )
}

// export function DiffPage(){

//     return(

//         <>
        
//         <h1>Hello world</h1>
//         </>
//     )
// }
